<template>
  <v-container>
    <div class="mt-6 d-flex justify-space-around justify-sm-center">
      <v-radio-group v-model="payType" row mandatory class="ma-0 pa-0">
        <v-radio v-if="$store.getters.getPayUrlForH5" label="微信支付" :value="0"></v-radio>
        <v-radio label="转账缴费" :value="1"></v-radio>
      </v-radio-group>
    </div>
    <div class="d-flex justify-space-around justify-sm-center red--text">
      <span v-if="payType === 0">请及时支付，关掉此页面后，请在参会登记管理-会议缴费中进行支付。</span>
      <span v-else>请线下转账缴费，转账后，及时上传缴费凭证。关掉此页面后，请在参会登记管理-会议缴费中进行支付。</span>
    </div>
    <v-row no-gutters v-if="payType === 1" class="mt-6">
      <v-col cols="12" sm="2" class="mr-2 d-none d-sm-flex">
        <span class="mt-1 ml-auto">上传缴费凭证：</span>
      </v-col>
      <v-col>
        <v-row no-gutters>
          <v-col cols="12" sm="6">
            <v-file-input name="file" v-model="file" truncate-length="20" accept="image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt" outlined dense prepend-icon="" prepend-inner-icon="mdi-camera" show-size placeholder="上传文件" @change="fileEvent()" @click:clear="src=null"></v-file-input>
          </v-col>
          <v-col cols="12" sm="10" v-if="src">
            <van-image fit="cover" lazy-load height="120" width="120" :src="src"></van-image>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="my-6 d-flex justify-space-around justify-sm-center">
      <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="$emit('fatherEvent', 'back')">{{$t('lang.back')}}</v-btn>
      <v-btn v-if="payType === 0" color="primary" style="text-transform:none;" @click="pay()">支付</v-btn>
      <v-btn v-else color="primary" style="text-transform:none;" :loading="loading" @click="uploadImg()">{{$t('lang.submit')}}</v-btn>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import utils from '../utils/utils.js'
export default {
  name: 'Pay',
  props: ['data'],
  data: () => ({
    payType: 0,
    src: null,
    file: null,
    loading: false,
    snackbar: false,
    msg: ''
  }),
  mounted () {
    // this.initWx()
  },
  methods: {
    isWeiXin () {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') !== -1) {
        return true
      } else {
        return false
      }
    },
    pay () {
      if (this.getPayUrl()/* && this.$store.getters.getTotalFee !== '0' */) {
        if (this.$store.getters.getLanguage === 0 && utils.methods.isMobile() && !this.isWeiXin()) {
          this.msg = '请在微信或电脑端打开链接，点击“会议缴费”完成缴费操作。'
          this.snackbar = true
        } else {
          window.location.href = this.getPayUrl()
        }
      }
    },
    getPayUrl () {
      let web = this.$store.getters.getPayUrlForWeb
      let h5 = this.$store.getters.getPayUrlForH5
      if (this.$store.getters.getLanguage !== 0) {
        web = ''
        h5 = ''
      }
      return utils.methods.isMobile() ? h5 : web
    },
    getImg (file) {
      let url = ''
      if (window.createObjectURL !== undefined) { // basic
        url = window.createObjectURL(file)
      } else if (window.URL !== undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    fileEvent (f) {
      console.info(this.file)
      this.src = this.file && this.file.type.indexOf('image') !== -1 ? this.getImg(this.file) : null
    },
    uploadImg (f) {
      if (this.file) {
        this.loading = true
        const formData = new FormData()
        formData.append('files', this.file)
        this.$http({
          requestBase: 'VUE_APP_API',
          method: 'post',
          url: '/SignUp/UploadFiles',
          data: formData
        }).then(res => {
          console.log(res)
          if (res.data.ret === 0) {
            this.submit(res.data.msg)
          } else {
            this.loading = false
            this.msg = res.data.msg
            this.snackbar = true
          }
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      }
    },
    submit (url) {
      this.$http({
        requestBase: 'VUE_APP_API',
        method: 'post',
        url: '/SignUp/SetUserSignUpPaymentVoucher',
        data: {
          UserSignUpId: this.$store.getters.getUserSignUpId,
          PaymentVoucherUrl: url
        }
      }).then(res => {
        console.log(res)
        this.msg = res.data.msg
        this.snackbar = true
        this.loading = false
        if (res.data.ret === 0) {
          this.$emit('fatherEvent', 'back')
          this.$emit('showSnack', res.data.msg)
        }
      }).catch(e => {
        this.loading = false
        console.log(e)
      })
    }
  }
}
</script>
